import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileAiSummarySectionTranslation = SectionTranslationModel<{
  developmentAreas: string;
  strengths: string;
}>;

export const employeeProfileAiSummarySectionTranslation: EmployeeProfileAiSummarySectionTranslation =
  {
    content: {
      developmentAreas: 'Obszary do rozwoju',
      strengths: 'Mocne strony',
    },
    headerTitle: 'Podsumowanie AI',
    headerTitleShorter: 'Podsumowanie',
  };
